module.exports = {"210103004":"大西街道","210103005":"滨河街道","210103006":"万莲街道","210103010":"大南街道","210103011":"山东庙街道","210103013":"朱剪炉街道","210103014":"新北站街道","210103015":"风雨坛街道","210103017":"皇城街道","210103018":"五里河街道","210103019":"南塔街道","210103020":"泉园街道","210103021":"丰乐街道","210103022":"马官桥街道","210103023":"东陵街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/210103.json
// module id = 453
// module chunks = 0